import { ListDivider, ListHeadline } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const DividerReservationListItem = ({
    resultCount = 0,
    ownedReservations = true,
}: {
    resultCount?: number;
    ownedReservations: boolean;
}) => (
    <>
        {resultCount > 0 ? (
            <>
                <ListDivider />
                <ListHeadline>
                    <LocalizedText
                        textKey={
                            ownedReservations
                                ? TextKey.ProcessPaymentLinkPaymentToReservationReservationSelectDropDownOptionSectionTitle
                                : TextKey.ProcessPaymentLinkPaymentToReservationOtherReservationSelectDropDownOptionSectionTitle
                        }
                    />
                </ListHeadline>
            </>
        ) : null}
    </>
);
